// assets/quick-view.js
document.addEventListener('DOMContentLoaded', function () {
  const modal = document.getElementById('quick-view-modal');
  const closeBtn = modal.querySelector('.close');
  const viewDetailBtn = modal.querySelector('.view-detail');

  // Function to fetch product data and populate the modal
  function fetchProductData(productHandle) {
    fetch(`/products/${productHandle}.js`)
      .then(response => {
        if (!response.ok) {
          throw new Error(`Network response was not ok: ${response.statusText}`);
        }
        return response.json();
      })
      .then(product => {
        populateModal(product);
        modal.style.display = 'flex';
      })
      .catch(error => console.error('Error fetching product data:', error));
  }

  // Function to populate the modal with product data
  function populateModal(product) {
    modal.querySelector('.product-title').textContent = product.title;

    // Display main image
    modal.querySelector('.product-image img').src = product.images[0];
    modal.querySelector('.product-image img').alt = product.title;

    // Display image gallery
    const galleryContainer = modal.querySelector('.product-image-gallery');
    galleryContainer.innerHTML = '';
    product.images.forEach((image, index) => {
      const thumbnail = document.createElement('img');
      thumbnail.src = image;
      thumbnail.alt = product.title;
      thumbnail.classList.add('thumbnail-image');
      thumbnail.addEventListener('click', function () {
        modal.querySelector('.product-image img').src = image;
      });
      galleryContainer.appendChild(thumbnail);
    });

    modal.querySelector('.product-price').textContent = `$${(product.price / 100).toFixed(2)}`;
    modal.querySelector('.product-description').innerHTML = product.description;

    // Check if options are available
    if (product.options && product.options.length > 0) {
      const optionsHtml = product.options.map((option, index) => {
        const uniqueValues = [...new Set(product.variants.map(variant => variant.options[index]))];
        const valuesHtml = uniqueValues.map(value => `<option value="${value}">${value}</option>`).join('');
        return `
          <div class="product-option">
            <div class=""><label for="option-${index}">${option.name}</label></div>
            <div class="selector">
              <select id="option-${index}" data-option-index="${index}">
                ${valuesHtml}
              </select>
            </div>
          </div>
        `;
      }).join('');
      modal.querySelector('.product-options').innerHTML = optionsHtml;
    } else {
      // Hide the product options if no options are available
      modal.querySelector('.product-options').innerHTML = '';
    }

    // Set data attributes
    modal.querySelector('.add-to-cart').dataset.productId = product.handle;
    modal.querySelector('.view-detail').href = `/products/${product.handle}`; // Set the href for View Detail button
  }

  // Event listener for Quick View buttons
  document.querySelectorAll('.quick-view-button').forEach(button => {
    button.addEventListener('click', function () {
      const productHandle = this.dataset.productId;
      fetchProductData(productHandle);
    });
  });

  // Event listener to close the modal
  closeBtn.onclick = function () {
    modal.style.display = 'none';
   
  };

  // Event listener to close the modal when clicking outside of it
  window.onclick = function (event) {
    if (event.target == modal) {
      modal.style.display = 'none';
    }
  };

  // Event listener for Add to Cart button
  const addToCartBtn = modal.querySelector('.add-to-cart');
  addToCartBtn.addEventListener('click', function () {
    const selectedOptions = Array.from(modal.querySelectorAll('.product-option select')).map(select => select.value);
    const productHandle = this.dataset.productId;

    fetch(`/products/${productHandle}.js`)
      .then(response => {
        if (!response.ok) {
          throw new Error(`Network response was not ok: ${response.statusText}`);
        }
        return response.json();
      })
      .then(product => {
        console.log('Product:', product);
        console.log('Selected Options:', selectedOptions);

        const selectedVariant = product.variants.find(variant => {
          return variant.options.every((option, index) => option === selectedOptions[index]);
        });

        console.log('Selected Variant:', selectedVariant);

        if (selectedVariant) {
          // Add the selected variant to the cart
          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({
              id: selectedVariant.id,
              quantity: 1
            })
          })
          .then(response => {
            if (!response.ok) {
              throw new Error(`Network response was not ok: ${response.statusText}`);
            }
            return response.json();
          })
          .then(data => {
            if (data.status && data.status === 'success') {
              alert('Product added to cart!');
              modal.style.display = 'none';
            } else {
              alert('Error adding product to cart.');
            }
          })
          .catch(error => {
            console.error('Error adding product to cart:', error);
            alert('Error adding product to cart.');
          });
        } else {
          alert('Selected variant not available.');
        }
      })
      .catch(error => {
        console.error('Error fetching product variant:', error);
        alert('Error fetching product variant.');
      });
  });
});
